import { render } from "./Replace.vue?vue&type=template&id=28911de0"
import script from "./Replace.vue?vue&type=script&lang=js"
export * from "./Replace.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__